const getSessionStorage = () => {
  try {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
  } catch (error) {
    // Some mobile in-app browsers expose Storage but deny access to it.
    return null;
  }
};

export const safeSessionStorage = {
  getItem(key) {
    try {
      return getSessionStorage()?.getItem(key) ?? null;
    } catch (error) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      getSessionStorage()?.setItem(key, value);
    } catch (error) {
      // Storage is optional; the app must remain usable without it.
    }
  },
  removeItem(key) {
    try {
      getSessionStorage()?.removeItem(key);
    } catch (error) {
      // Storage is optional; the app must remain usable without it.
    }
  },
};
